export const pageNames = {
  home: 'page.affhub.home',
  programs: 'page.affhub.programs',
  products: 'page.affhub.products',
  signIn: 'page.affhub.signin',
  signUp: 'page.affhub.signup',
  setPassword: 'page.affhub.setpassword',
  joinProgram: 'page.affhub.joinprogram',
  joinProgramConfirmation: 'page.affhub.joinprogram.confirmation',
  bexSearch: 'page.afffhub.products.bexsearch',
  bookmarklet: 'page.afffhub.products.bookmarklet',
  deeplink: 'page.afffhub.products.deeplink',
  quicklinks: 'page.affhub.products.quicklinks',
  search: 'page.affhub.products.search',
  vrboSearch: 'page.affhub.products.vrbosearch',
};
